import React, { useEffect } from 'react';
import { useLazyGetPageQuery } from '../../../redux/actions/Customer/FooterCustomer';
import { LegalPageLayout } from '../../../components/customer/LegalPageLayout';

export const ReturnExchangePolicyScreen: React.FC = () => {
    const [triggerGetPage, { data: response, isLoading, isError }] = useLazyGetPageQuery();

    useEffect(() => {
        triggerGetPage(4); // WebsitePageType.ReturnAndExchangePolicy = 4
    }, [triggerGetPage]);

    return (
        <LegalPageLayout
            title="Return & Exchange Policy"
            subtitle="Learn about our rules for returns, exchanges, and refunds."
            isLoading={isLoading}
            isError={isError}
            contentData={response?.value?.data || null}
        />
    );
};
export default ReturnExchangePolicyScreen;